import React from 'react'
import { ReviewEl } from '../elements'
import Avatar from '../../../../../../../../../../../../Components/Avatar'
import date from 'date-and-time'

function Review({
  data: {
    createdAt,
    review,
    userInfo: {
      name,
      profilePicture: { location: image },
    },
  },
}) {
  return (
    <ReviewEl>
      <div className='basicInfo'>
        <div className='userInfo'>
          <Avatar name={name} image={image} size={3} />
          <p>
            {name} <br />
            {date.format(new Date(createdAt), 'DD MMM YYYY')}
          </p>
        </div>
      </div>

      <div className='description'>
        <p>{review}</p>
      </div>
    </ReviewEl>
  )
}

export default Review
